import React, { useState, useEffect, useCallback } from "react";
// import { Link } from "gatsby";
import { graphql } from "gatsby"
import PostLink from "../components/blog/post-link"
import Seo from "../components/seo";
import Layout from "../components/layout/layout"
import { Container, Row, Col, Button } from "react-bootstrap";
import { BlogMeta } from "../data/metaData";
// import UpdatedBlogSubscribe from "../components/blog/updated-blog-subscribe-form";

import { AnchorLink } from "gatsby-plugin-anchor-links";
// import { Navigation } from "swiper/modules";
// import { Swiper, SwiperSlide } from 'swiper/react';

export const Head = () => (
  <Seo
    title={BlogMeta.metaTitle}
    description={BlogMeta.metaDescription}
    ogImage={BlogMeta.ogImage}
    twitterImage={BlogMeta.twitterImage}
  />
)

const Blog = ({ data }) => {

  const [Category, setCategory] = useState([]);
  const [catFilter, setFilter] = useState('');
  const [active, setActive] = useState("false");
  const [actives, setActives] = useState("false");
  const [maxRange, setMaxRange] = useState(9);
  const Posts = data.allMdx.edges
  const filtered = Posts.filter(post => post.node.frontmatter.categories.some(i => catFilter.includes(i)));

  const allPostLnth = Posts.length;
  const filterLnth = filtered.length
  const isMoreFilter = maxRange < filterLnth
  const isMorePost = maxRange < allPostLnth

  const toggle = (id) => {
    setActive(id);
    setActives('');
  }
  const handleToggle = () => {
    setFilter('')
    setActives('true');
    setActive('');
    setMaxRange(9);

  };

  const handleLoadMore = useCallback(() => {
    setMaxRange(prevRange => prevRange + 9);
  }, [])


  useEffect(() => {
    const categoriesArray = [];
    Posts.forEach(allCat => {
      const allCategories = allCat.node.frontmatter.categories;

      allCategories.forEach(concatCat => {
        categoriesArray.push(concatCat)

      });
    });
    const uniqueCategories = [...new Set(categoriesArray)];
    setCategory(uniqueCategories);

  }, [Posts]);

  // let maincategoriesFound = [];

  // Posts.map((post) => (
  //   post?.node?.frontmatter?.maincategories.map((category) => {
  //     return (
  //       maincategoriesFound.indexOf(category) === -1 ?
  //         maincategoriesFound.push(category) : null
  //     )
  //   })
  // ))

  // const blogdata = [
  //   {
  //     iconclass: "icon-1",
  //     title: "Technology",
  //     des: "Discover expert insights on a range of technologies and stay updated with the latest industry trends and market updates.",
  //     url: "/blog/category/technology/"
  //   },
  //   {
  //     iconclass: "icon-2",
  //     title: "Services",
  //     des: "Explore the most popular IT services we offer - App development, Custom software development, Digital transformation & more.",
  //     url: "/blog/category/services/"
  //   },
  //   {
  //     iconclass: "icon-3",
  //     title: "Industry",
  //     des: "Technology for industries is now as important as oxygen for humans. Stay updated in your industry with the latest technology trends.",
  //     url: "/blog/category/industry/"
  //   },
  // ]
  return (
    <>
      <Layout>
        {/* <section className="section  background-pattern">
          <Container className="py-5 mt-lg-5">
            <div className="banner-content text-center max-width-950 mx-auto py-lg-5">
              <h1 className="mb-4">
                Blogs on <span className="text-primary">Emerging Tech</span>
              </h1>
              <p className="mx-auto lead mb-0">Empower people through technology and innovative solutions</p> */}
        {/* <div className="blog-search max-width-700 mx-auto mt-5">
                  <InputGroup size="lg">
                    <Form.Control
                      placeholder="What are you looking for?"
                      aria-label="What are you looking for?"
                      aria-describedby="basic-addon2"
                    />
                    <Button className="btn btn-primary-theme" id="button-addon2">
                      Search
                    </Button>
                  </InputGroup>
                </div> */}
        {/* </div> */}

        {/* {maincategoriesFound.map((maincategory, index) => {
                const iconData = [
                  { class: "icon-1" },
                  { class: "icon-2" },
                  { class: "icon-3" }
                ];

                const descriptionData = [
                  { content: "Discover expert insights on a range of technologies and stay updated with the latest industry trends and market updates." },
                  { content: "Explore the most popular IT services we offer - App development, Custom software development, Digital transformation & more." },
                  { content: "Technology for industries is now as important as oxygen for humans. Stay updated in your industry with the latest technology trends." }
                ];

                // Get the icon and description data based on the index
                const icon = iconData[index].class;
                const description = descriptionData[index].content;

                return (
                  <Col key={index}>
                    <div className="dark-box-2 border equal-height d-flex flex-column">
                      <i className={`blog-sprite-icon icon-size-70 mb-4 ${icon}`}></i>
                      <h3 className="mb-3 font-size-24">{maincategory}</h3>
                      <p>
                        {description}
                      </p>
                      <div className="text-start mt-auto">
                        <Link to={`/blog/category/${maincategory}`.toLowerCase().replace(/ /g, "-")} className="btn btn-link px-0">
                          <span>Discover Blogs</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </Col>
                );
              })} */}

        {/* <Row className="g-4 py-5 mb-5" xs={1} sm={1} md={2} lg={3}>
              {
                blogdata.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 border equal-height d-flex flex-column">
                      <i className={`blog-sprite-icon ${item.iconclass} icon-size-70 mb-4`}></i>
                      <h3 className="mb-3 font-size-24">{item.title}</h3>
                      <p>
                        {item.des}
                      </p>
                      <div className="text-start mt-auto">
                        <Link to={item.url} className="btn btn-link px-0">
                          <span>Discover Blogs</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))
              }
            </Row> */}
        {/* </Container>
        </section> */}
        <section className="section bg-light 0pt-0">
          {/* <Container className="py-5 subscribe-form">
            <UpdatedBlogSubscribe />
          </Container> */}

          <Container className="py-5">
            {/* <div className="mb-5">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/"><Image loading="lazy" className="lazyload align-top" src={SmallIcon} width={25} height={25} alt="logo" /></Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Blog</li>
                </ol>
              </nav>
            </div> */}
            <div className="banner-content mb-5 pt-lg-5">
              <h1 className="mb-4">
                Blogs on <span className="text-primary">Emerging Tech</span>
              </h1>
              <p className="mx-auto lead mb-0">Empower people through technology and innovative solutions</p>
            </div>
            <div id="blogRow"></div>
            <div className="d-lg-flex mb-5">
              <div className="nav-tabs-link with-button d-flex flex-wrap flex-fill">
                {/* <ul className="list-unstyled d-flex align-items-center mb-0 flex-nowrap">
                <li className="active"><Link to="/blog.html">Blogs</Link></li>
                <li><Link to="/resources.html">Whitepapers</Link></li>
              </ul> */}
                {/* <Swiper
                slidesPerView={"auto"}
                modules={[Navigation]}
                navigation={true}
              > */}
                <div className={`${actives ? 'active' : ''}`} >
                  <Button variant=""
                    onClick={handleToggle} >
                    <AnchorLink to={process.env.NODE_ENV === `development` ? `/blog/#blogRow` : `/blog.html#blogRow`} stripHash>
                      All
                    </AnchorLink>
                  </Button>
                </div>
                {/* {Category.map((categories, index) => {
                return (
                  <div role="button" tabIndex="0" key={index} className={`${active === categories ? 'active' : ''}`}
                    onClick={() => toggle(categories)}
                    onKeyDown={() => toggle(categories)}>
                    <Button variant=""
                      onClick={() => { setFilter(categories); setMaxRange(9); }}
                      key={categories}>
                      <AnchorLink to={process.env.NODE_ENV === `development` ? `/blog/#blogRow` : `/blog.html#blogRow`} stripHash>
                        {categories}
                      </AnchorLink>
                    </Button>
                  </div>
                );
              })} */}
                {/* </Swiper> */}

                {Category.map((categories, index) => (
                  // {Category.map((categories, index) => index < 9 && (
                  <div role="button" tabIndex="0" key={index} className={`${active === categories ? 'active' : ''}`}
                    onClick={() => toggle(categories)}
                    onKeyDown={() => toggle(categories)} aria-label="Category Filter">
                    <Button variant=""
                      onClick={() => { setFilter(categories); setMaxRange(9); }}
                      key={categories}>
                      <AnchorLink to={process.env.NODE_ENV === `development` ? `/blog/#blogRow` : `/blog.html#blogRow`} stripHash>
                        {categories}
                      </AnchorLink>
                    </Button>
                  </div>
                ))}

              </div>
              {/* <Dropdown className="blog-category-dropdown" align="end">
                <Dropdown.Toggle variant="" id="blog-category-dropdown">
                  All Category
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {Category.map((categories, index) => index > 8 && (
                    <div role="button" tabIndex="0" key={index} className={`${active === categories ? 'p-0 d-grid active' : 'p-0 d-grid'}`}
                      onClick={() => toggle(categories)}
                      onKeyDown={() => toggle(categories)} aria-label="Category Filter">
                      <Button variant="" className="p-0"
                        onClick={() => { setFilter(categories); setMaxRange(9); }}
                        key={categories}>
                        <AnchorLink to={process.env.NODE_ENV === `development` ? `/blog/#blogRow` : `/blog.html#blogRow`} stripHash className="dropdown-item">
                          {categories}
                        </AnchorLink>
                      </Button>
                    </div>
                  ))}
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
            <Row xs={1} sm={1} md={2} lg={3} className="g-4">
              {(catFilter ? filtered.slice(0, maxRange) : Posts.slice(0, maxRange)).map((edge, index) => (
                <PostLink key={index} post={edge.node} site={data.site} />
              ))}
              {(catFilter ? isMoreFilter : isMorePost) ? (
                <Col lg={12} md={12} className="mt-5 text-center">
                  <Button variant="" size="lg" onClick={handleLoadMore} className="btn-primary-theme-outline btn-240">Load More</Button>
                </Col>
              ) : (
                <Col lg={12} md={12} className="mt-5 text-center">
                  <p>No more results</p>
                </Col>
              )}
            </Row>
          </Container>
        </section>
      </Layout>
    </>)
}

export default Blog

export const blogQuery = graphql`
query AllBlogPageQuery {
  site {
    siteMetadata {
        author
    }
  }
  allMdx( 
    sort: {frontmatter: {modifyDate: DESC}}
    ) {
    edges {
      node {
        id
        fields {
          slug
          timeToRead {
            text
          }
        }
        excerpt(pruneLength: 250)
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          modifyDate(formatString: "MMMM DD, YYYY")
          title
          categories
          featured {
            childImageSharp {
              gatsbyImageData(width: 384)
            }
          }  
          author {
            name
            img {
              childImageSharp {
                gatsbyImageData(width: 30)
              }
            }
          }
        }
      }
    }
  }
}`